import Vue from "vue";
import VueRouter from "vue-router";
import Home from "./pages/Home.vue";
import Watercourses from "./pages/Watercourses.vue";
import Layout from "./pages/Layout.vue";
import Watercourse from "./pages/Watercourse.vue";
import MethodAndClassification from "./pages/MethodAndClassification.vue";
import Literature from "./pages/Literature.vue";
import Status from "./pages/Status.vue";

Vue.use(VueRouter);

export default new VueRouter({
  routes: [
    {
      path: "/",
      redirect: { name: "watercourses" },
      component: Layout,
      name: "layout",
      children: [
        {
          path: "watercourses",
          name: "watercourses",
          component: Watercourses,
          children: [
            {
              path: "watercourse/:id",
              name: "watercourse",
              component: Watercourse
            },
            {
              path: "methodAndClassification",
              name: "methodAndClassification",
              component: MethodAndClassification
            },
            {
              path: "literature",
              name: "literature",
              component: Literature
            },
            {
              path: "status",
              name: "status",
              component: Status
            }
          ]
        },
        {
          path: "home",
          name: "home",
          component: Home
        }
      ]
    }
  ]
});
